import type { StakeholderRole, TrustFamily } from '@wedpo/soc2';
import { roleShortLabels } from '@wedpo/soc2';

/** The we/dpo gradient slash wordmark used in the topbar. */
export function SlashMark() {
  return (
    <span className="mark">
      <span>we</span>
      <svg className="slash" viewBox="0 0 12 22.08" aria-hidden>
        <defs>
          <linearGradient id="soc2-slash" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#7B3FE4" />
            <stop offset="50%" stopColor="#3E5CCF" />
            <stop offset="100%" stopColor="#3EC7D9" />
          </linearGradient>
        </defs>
        <line
          x1="1.32"
          y1="20.76"
          x2="10.68"
          y2="1.32"
          stroke="url(#soc2-slash)"
          strokeWidth="2.64"
          strokeLinecap="round"
        />
      </svg>
      <span>dpo</span>
    </span>
  );
}

export function OwnerBadge({ role }: { role: StakeholderRole }) {
  return (
    <span className="own">
      <span className={`owdot ow-${role}`} />
      {roleShortLabels[role]}
    </span>
  );
}

export function FamilyChips({ families }: { families: TrustFamily[] }) {
  return (
    <>
      {families.map((f) => (
        <span key={f} className={`fchip ${f}`}>
          {f}
        </span>
      ))}
    </>
  );
}

export function ControlChips({ codes }: { codes: string[] }) {
  return (
    <>
      {codes.map((c) => (
        <span key={c} className="fchip">
          {c}
        </span>
      ))}
    </>
  );
}
